var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3333 8V40.8667H88V66H5V8H60.3333Z",
    fill: "#F2CA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43.2857L76.1626 24H61V51",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 72.5C34.5 77.4467 30.2712 81.5 25 81.5C19.7288 81.5 15.5 77.4467 15.5 72.5C15.5 67.5533 19.7288 63.5 25 63.5C30.2712 63.5 34.5 67.5533 34.5 72.5Z",
    stroke: "#383434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 72.5C79.5 77.4467 75.2712 81.5 70 81.5C64.7288 81.5 60.5 77.4467 60.5 72.5C60.5 67.5533 64.7288 63.5 70 63.5C75.2712 63.5 79.5 67.5533 79.5 72.5Z",
    stroke: "#383434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H43",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26L25 26",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 33L13 33",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBc);
export default __webpack_public_path__ + "static/media/BC.c07d07ac2765c67113815d3a779f9227.svg";
export { ForwardRef as ReactComponent };